export default __webpack_public_path__ + "static/media/2094-00.62e190ff.jpg";